
<h1 class='save-line-head' i18n='@@transaction-summary'>Sommario transazioni</h1>
<h4 i18n='@@text-transactionSummary'>In quest'area è possibile effettuare e gestire transazioni in ambiente di test</h4>

<!-- List Transaction -->
<ng-container>
  <app-transactions-list></app-transactions-list>
</ng-container>